import { render, staticRenderFns } from "./buttonManage.vue?vue&type=template&id=510e0ecc"
import script from "./buttonManage.vue?vue&type=script&lang=js"
export * from "./buttonManage.vue?vue&type=script&lang=js"
import style0 from "./buttonManage.vue?vue&type=style&index=0&id=510e0ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports